module.exports = __webpack_public_path__ + "media/customizations/ranchlife/missing-a849e0932181546c129c2239cd160d42.jpg";